import { useId } from "react";
import type { SortOption } from "../../api/types";

/** Display labels for each sort option. */
const SORT_LABELS: Record<SortOption, string> = {
  MIXED: "Mixed",
  NEWEST: "Newest first",
  OLDEST: "Oldest first",
  TITLE_ASC: "Title A–Z",
  TITLE_DESC: "Title Z–A",
  RELEVANCE: "Best match",
};

/** Order the options appear in the dropdown. */
const ORDER: SortOption[] = [
  "MIXED",
  "NEWEST",
  "OLDEST",
  "TITLE_ASC",
  "TITLE_DESC",
  "RELEVANCE",
];

interface SortControlProps {
  value: SortOption;
  onChange: (value: SortOption) => void;
}

export function SortControl({ value, onChange }: SortControlProps) {
  const id = useId();
  return (
    <div className="sort">
      <label htmlFor={id}>Sort</label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value as SortOption)}
      >
        {ORDER.map((opt) => (
          <option key={opt} value={opt}>
            {SORT_LABELS[opt]}
          </option>
        ))}
      </select>
    </div>
  );
}
